import getApiClient from '../../../../../plugins/api'

export default {
    loadChart: function() {
        const self = this,
            api = getApiClient(self.$store)

        self.$store.commit('startLoading')

        api.get('/agency/orders', {
            params: {
                futureTrips: false,
                itemsPerPage: 10,
                status: [3, 8]
            }
        })
            .then(result => {
                self.data = result.data['hydra:member']
            })
            .catch(error => {
                console.log(error)
            })
            .finally(() => {
                self.$store.commit('stopLoading')
            })
    }
}
